module.exports = __webpack_public_path__ + "img/s-america-custom.10cb6a9d.png";